// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Edit = function Edit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.038 13.32-.73 2.479-.394 1.34a.762.762 0 0 0 .943.948l1.342-.396 2.48-.73a2.8 2.8 0 0 0 1.06-.584q.065-.058.126-.121l9.655-9.652a2.03 2.03 0 0 0 0-2.872l-1.25-1.254a2.03 2.03 0 0 0-2.873 0l-9.655 9.655c-.33.33-.57.74-.704 1.187m1.46.429c.054-.178.143-.343.266-.483.02-.019.035-.038.054-.057l7.253-7.249 1.967 1.968L6.79 15.18c-.149.15-.336.26-.54.32l-.742.22-1.74.51.512-1.739z"
  }));
};
